// Mapa kategorií na barvu + emoji + český label.
// Sjednoceno s PRD §9. Kategorii vrací AI scoring v ingestu.

const STYLES: Record<string, { label: string; emoji: string; classes: string }> = {
  regulation: { label: 'Regulace', emoji: '🏠', classes: 'bg-blue-100 text-blue-800' },
  prices: { label: 'Ceny & trh', emoji: '📈', classes: 'bg-positive-bg text-positive' },
  infrastructure: { label: 'Infrastruktura', emoji: '🏗️', classes: 'bg-orange-100 text-orange-800' },
  projects: { label: 'Projekty', emoji: '🏢', classes: 'bg-purple-100 text-purple-800' },
  geopolitics: { label: 'Geopolitika', emoji: '🌍', classes: 'bg-red-100 text-red-800' },
  economy: { label: 'Ekonomika', emoji: '💰', classes: 'bg-warning-bg text-warning' },
};

const FALLBACK = { label: 'Ostatní', emoji: '📰', classes: 'bg-gray-100 text-gray-700' };

export default function CategoryBadge({ category }: { category: string }) {
  const style = STYLES[category] ?? FALLBACK;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide ${style.classes}`}
    >
      <span aria-hidden>{style.emoji}</span>
      {style.label}
    </span>
  );
}
